import axios from 'axios'
import React, { useCallback, useEffect, useState } from 'react'
import TreeMaker from "./TreeMaker/TreeMaker.js"
import MenuIcon from '@mui/icons-material/Menu';
import hieraBackground from "../images/hieraBackground.jpg"
import Autosuggest from 'react-autosuggest';
import AutosuggestHighlightMatch from 'autosuggest-highlight/match';
import AutosuggestHighlightParse from 'autosuggest-highlight/parse';

function Hierarchy({ serverURL, user, setShowSideOverlay }) {

    const [notificationData, setNotificationData] = useState(null)
    const [notificationView, setNotificationView] = useState(null)
    const [animated, setAnimated] = useState(false)


    const [allMembers, setAllMembers] = useState([])


    const [value, setValue] = useState('');
    const [suggestions, setSuggestions] = useState([]);

    function escapeRegexCharacters(str) {
        return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    function getSuggestions(value, memersList) {

        const escapedValue = escapeRegexCharacters(value.trim());
        if (escapedValue === '') {
            return [];
        }

        const regex = new RegExp('\\b' + escapedValue, 'i');

        return memersList.filter((person) => { if (regex.test(JSON.stringify(person))) { return getSuggestionValue(person) } });
    }

    function getSuggestionValue(suggestion) {
        return `${suggestion["Employee Name"]}`;
    }

    function renderSuggestion(suggestion, { query }) {
        const suggestionTextName = `${suggestion["Employee Name"]}`;
        const matchesName = AutosuggestHighlightMatch(suggestionTextName, query);
        const nameParts = AutosuggestHighlightParse(suggestionTextName, matchesName);

        const suggestionTextEmail = `${suggestion["Official Mail Id"]}`;
        const matchesEmail = AutosuggestHighlightMatch(suggestionTextEmail, query);
        const emailParts = AutosuggestHighlightParse(suggestionTextEmail, matchesEmail);

        const suggestionTextDepartment = `${suggestion["Process / Department"]}`;
        const matchesDepartment = AutosuggestHighlightMatch(suggestionTextDepartment, query);
        const departmentParts = AutosuggestHighlightParse(suggestionTextDepartment, matchesDepartment);


        const suggestionTextLocation = `${suggestion["Company Name"]}, ${suggestion["Location"]}`;
        const matchesLocation = AutosuggestHighlightMatch(suggestionTextLocation, query);
        const locationParts = AutosuggestHighlightParse(suggestionTextLocation, matchesLocation);

        const finalCardIdToLocate = user.email.toLowerCase() === suggestion["Official Mail Id"].toLowerCase() ? "myCard" : `memberCard_${suggestion["Official Mail Id"].toLowerCase()}`

        return (
            <div className='w-100 d-flex gap-2 align-items-center p-2' onClick={() => { getView("my_tree", finalCardIdToLocate); }}>
                <img className='memberSearchFilterImage' src={`https://placehold.co/48x48/fffaef/000000?text=${suggestion["Employee Name"].split(" ").map((words, key) => { return words.split("")[0] }).join("+").toUpperCase()}`} />
                <div className='d-flex flex-column gap-0 w-100 text-truncate'>
                    <span>
                        {nameParts.map((part, index) => {
                            return (
                                <span className={part.highlight ? 'highlight' : null} key={index}>{part.text}</span>
                            );
                        })}
                    </span>
                    <span className='w-100 text-truncate'>
                        {emailParts.map((part, index) => {
                            return (
                                <span className={part.highlight ? 'highlight' : null} key={index}>{part.text}</span>
                            );
                        })}
                    </span>
                    <span className='w-100 text-truncate'>
                        {departmentParts.map((part, index) => {
                            return (
                                <span className={part.highlight ? 'highlight' : null} key={index}>{part.text}</span>
                            );
                        })}
                    </span>
                    <span className='w-100 text-truncate'>
                        {locationParts.map((part, index) => {
                            return (
                                <span className={part.highlight ? 'highlight' : null} key={index}>{part.text}</span>
                            );
                        })}
                    </span>
                </div>
            </div>

        );
    }


    const onChange = useCallback((event, { newValue }) => {
        setValue(newValue);
    }, []);

    const onSuggestionsFetchRequested = useCallback(({ value }, members) => {
        setSuggestions(getSuggestions(value, members));
    }, []);

    const onSuggestionsClearRequested = useCallback(() => {
        setSuggestions([]);
    }, []);

    const inputProps = {
        placeholder: "Search Person",
        value,
        onChange
    };


    const getHierarchy = async () => {
        const getMembersNow = await axios.post(serverURL + "/users/getHierarchy")
        if (getMembersNow.status === 200) {
            let memberList = []

            getMembersNow.data.map((data, key) => {
                const core = data.submittedData

                const needed = {
                    "Employee Name": core["Employee Name"],
                    "Designation": core["Designation"],
                    "Official Mail Id": core["Official Mail Id"],
                    "Process / Department": core["Process / Department"],
                    "Location": core["Location"],
                    "Company Name": core["Company Name"],
                    "Reporting Manager's Email ID": core["Reporting Manager's Email ID"],
                }
                memberList.push(needed)
                return
            })


            setAllMembers(memberList)

            // ######################################################################################################################################


            // Helper function to build the hierarchy
            function buildHierarchy(employees) {
                const employeeMap = {}; // This map will store each employee by email
                const hierarchy = {};    // This will store the final hierarchy

                // First, map all employees by their Official Mail Id
                employees.forEach(employee => {
                    const employeeEmail = employee["Official Mail Id"].toLowerCase(); // Convert to lowercase for case-insensitive comparison
                    employeeMap[employeeEmail] = {};
                });

                // Now, build the hierarchy by linking employees to their managers
                employees.forEach(employee => {
                    const managerEmail = employee["Reporting Manager's Email ID"].toLowerCase(); // Convert to lowercase for case-insensitive comparison
                    const employeeEmail = employee["Official Mail Id"].toLowerCase();

                    // If the manager is the employee themselves, they should be at the top
                    if (managerEmail === employeeEmail) {
                        hierarchy[employeeEmail] = employeeMap[employeeEmail];
                    } else {
                        // Make sure the manager exists in the hierarchy, if not, initialize them
                        if (!employeeMap[managerEmail]) {
                            employeeMap[managerEmail] = {};
                        }

                        // Add the employee as a subordinate of their manager
                        employeeMap[managerEmail][employeeEmail] = employeeMap[employeeEmail];
                    }
                });

                // Return the final hierarchy
                return hierarchy;
            }

            // Call the function to build the hierarchy
            const employeeHierarchy = { "1": buildHierarchy(memberList) };

            // Log the hierarchy to view the results
            // console.log(employeeHierarchy);


            // ######################################################################################################################################


            const params = {
                1: { trad: 'Yes Group' },
            };

            TreeMaker(employeeHierarchy, memberList, user.email, {
                id: 'my_tree',
                card_click: function (element) {
                    navigator.clipboard.writeText(element.innerHTML).then(() => {
                        setNotificationData(`${element.getAttribute("data-type")} copied`)
                        setNotificationView(true)
                        setTimeout(() => {
                            setNotificationView(false)
                        }, 2000)
                    })
                },
                treeParams: params,
                link_width: '5px',
                link_color: 'white',
            });

            setTimeout(() => {
                getView("my_tree", "myCard")
            }, 400)
        } else {
            console.log(getMembersNow.data)
        }
    }

    const getView = (frameName, cardName) => {

        let scale = 1; // Initial scale
        let lastDistance = 0; // Store the last distance between fingers

        const zoomContainer = document.getElementById(frameName)
        const card = document.getElementById(cardName)

        if (card) {
            // changing to default view
            zoomContainer.style.transitionDuration = `1s`;
            zoomContainer.style.transform = `scale(1)`;

            setTimeout(() => {
                setAnimated(false)

                card.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" })

                setTimeout(() => {
                    card.style.transform = `scale(1.1)`
                    card.style.background = `gold`
                }, 900)
                setTimeout(() => {
                    card.style.transform = `scale(1)`
                    card.style.background = `rgb(253, 253, 217)`
                }, 1200)
            }, animated ? 1000 : 0)


            // Handle touch gestures for pinch zoom
            // zoomContainer.addEventListener('touchstart', (event) => {
            //     if (event.touches.length === 2) {
            //         lastDistance = calculateDistance(event.touches);
            //     }
            // });

            // zoomContainer.addEventListener('touchmove', (event) => {
            //     if (event.touches.length === 2) {
            //         const newDistance = calculateDistance(event.touches);
            //         const scaleChange = newDistance / lastDistance;

            //         scale *= scaleChange; // Update scale
            //         lastDistance = newDistance; // Update last distance

            //         // Apply transform based on the new scale
            //         zoomContainer.style.transitionDuration = `0s`;
            //         zoomContainer.style.transform = `scale(${scale})`;
            //         setAnimated(true)
            //     }
            // });

            // // Prevent default browser zoom behavior globally
            // window.addEventListener('wheel', (event) => {
            //     if (event.ctrlKey) {
            //         event.preventDefault(); // Stop browser zoom

            //         const scaleChange = event.deltaY < 0 ? 1.1 : 0.9; // Zoom in or out
            //         scale *= scaleChange;

            //         // Apply transform based on the new scale
            //         zoomContainer.style.transitionDuration = `0s`;
            //         zoomContainer.style.transform = `scale(${scale})`;
            //         setAnimated(true)
            //     }
            // }, { passive: false }); // Ensure passive is false to allow preventDefault

            // function calculateDistance(touches) {
            //     const [touch1, touch2] = touches;
            //     const dx = touch1.clientX - touch2.clientX;
            //     const dy = touch1.clientY - touch2.clientY;
            //     return Math.sqrt(dx * dx + dy * dy);
            // }
        } else {

            setNotificationView(true)
            setNotificationData("Hierarchy Not Found")


            setTimeout(() => {
                setNotificationView(false)
            }, 2000)

        }

    }

    useEffect(() => {
        getHierarchy()
    }, [])


    return (
        <>
            <div className="transback h-100 overflow-auto p-3 d-flex flex-column" style={{
                backgroundImage: `url(${hieraBackground})`,
                backgroundSize: "cover",
            }}>
                <button className='btn text-secondary rounded-pill px-3 py-1 d-flex d-lg-none d-xl-none d-xxl-none align-items-center gap-2' onClick={() => { setShowSideOverlay(true) }}>
                    <MenuIcon />
                </button>
                <div className="headerUserDetails py-1 mb-3 border-0 d-flex justify-content-between">
                    <span className='text-light' onClick={() => { getView("my_tree", "myCard") }}>Hierarchy</span>
                    <div className='d-flex gap-2 align-items-center justify-content-center text-dark px-2' style={{ cursor: "pointer" }} title={"Name: " + user.name + "\nEmail: " + user.email}>
                        <i className='fa fa-user'></i>
                        <span>{user.name}</span>
                    </div>
                </div>
                <div className='w-100 h-100 overflow-auto position-relative' style={{
                    background: "rgba(255, 255, 255, 0.1)",
                    backdropFilter: "blur(10px)",

                }}>
                    <div className='searchControls'>
                        {
                            allMembers ?
                                allMembers.length > 0 ?
                                    <Autosuggest
                                        suggestions={suggestions}
                                        onSuggestionsFetchRequested={(e) => { onSuggestionsFetchRequested(e, allMembers) }}
                                        onSuggestionsClearRequested={onSuggestionsClearRequested}
                                        getSuggestionValue={getSuggestionValue}
                                        renderSuggestion={renderSuggestion}
                                        inputProps={inputProps}
                                    />
                                    :
                                    ""
                                :
                                ""
                        }

                    </div>
                    <div id="my_tree" className='position-relative'></div>
                </div >
            </div>

            {
                <div className='popupMessages' style={{ opacity: notificationView ? "1" : "0" }}>
                    {notificationData}
                </div >
            }
        </>
    )
}

export default Hierarchy